export const refreshPage = () => {
  window.location.reload();
  window.location.href = '/';
};
